import { defineMessages } from "@/i18n";
import en from "./en";

export const settingsAiToolsMessages = defineMessages("settings-ai-tools", en);
